/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Close from "../../CloseBtn/Close";
import { popupcontext } from "../../../../context/Popupscontext";
import { isRTL } from "../../../../utils";

export default function FormHeader({ title, other, onClose }) {
  let { handleClose } = useContext(popupcontext);
  return (
    <>
      <div className="flex-between w-100" dir={!isRTL ? "ltr" : "rtl"}>
        <div className="fs-20 fw-600 text-capitalize">{title}</div>
        <Close
          style="close-32 close"
          close={
            onClose
              ? onClose
              : !other
              ? () => handleClose("form")
              : () => handleClose("notification")
          }
          img="Close"
        />
      </div>
    </>
  );
}
